import { firestore } from '@quintoandar/firebase-client';
import { AuthenticationService } from 'services/AuthenticationService';

export class FirestoreService {
  private static instance: firebase.firestore.Firestore;

  static async getInstance(): Promise<firebase.firestore.Firestore> {
    await AuthenticationService.authenticateToFirebaseIfNeeded();

    if (this.instance === undefined) {
      this.instance = firestore();
    }

    return this.instance;
  }

  static getChecklistDocumentPath({ userId, photoSessionId }: { userId: number, photoSessionId: number }): string {
    return `/appPhotographers/data/users/${userId}/checklists/${photoSessionId}`;
  }
}
